import { render, staticRenderFns } from "./Demands.vue?vue&type=template&id=626c25ca&"
import script from "./Demands.vue?vue&type=script&lang=js&"
export * from "./Demands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports